"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "EventProperties", {
  enumerable: true,
  get: function get() {
    return _AWTEventProperties.default;
  }
});

exports.telemetry = exports.Telemetry = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _webjsSdk = require("@aria/webjs-sdk");

var _AWTEventProperties = _interopRequireDefault(require("@aria/webjs-sdk/dist/src/webjs/AWTEventProperties"));

var _isTouch = require("../device/is-touch");

var _ISS = require("./ISS");

var _treatmentService = require("./treatmentService");

var Telemetry = /*#__PURE__*/function () {
  function Telemetry() {
    var _this = this;

    var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
    (0, _classCallCheck2.default)(this, Telemetry);
    this.isTouch = void 0;
    this.screenWidth = void 0;
    this.screenHeight = void 0;
    this.windowWidth = void 0;
    this.windowHeight = void 0;
    this.referrer = void 0;
    this.initialLocation = void 0;
    this._providers = [];
    this._defaultProvider = void 0;
    this._userAgent = void 0;
    this._initError = void 0;
    this._win = void 0;
    this._userObjectId = void 0;
    this._userTenantId = void 0;
    this._sessionId = void 0;

    this._onWindowResize = function () {
      try {
        _this.windowWidth = _this._win.innerWidth;
        _this.windowHeight = _this._win.innerWidth;
      } catch (err) {
        _this.logFailure('TelemetryResize', err + '');
      }
    };

    this._onBeforeUnload = function () {
      _this.logSession(_webjsSdk.AWTSessionState.Ended);

      _this.flushAndTeardown();
    };

    this._win = win;

    try {
      if (win.navigator !== undefined) {
        this._userAgent = win.navigator.userAgent;
      }

      win.addEventListener('beforeunload', this._onBeforeUnload);
      win.addEventListener('resize', this._onWindowResize);

      this._onWindowResize();

      this.isTouch = (0, _isTouch.isTouchDevice)(win);
      var screen = win.screen;
      this.referrer = this._win.document.referrer;
      this.initialLocation = this._win.location.href;
      this.screenWidth = screen.width;
      this.screenHeight = screen.height;
    } catch (err) {
      this._initError = err;
    }
  }

  (0, _createClass2.default)(Telemetry, [{
    key: "addProvider",
    value: function addProvider(provider) {
      this._providers.push(provider);
    }
  }, {
    key: "setDefaultProvider",
    value: function setDefaultProvider(provider) {
      this._defaultProvider = provider;
    }
  }, {
    key: "logSession",
    value: function logSession(state, properties) {
      var _context,
          _this2 = this;

      if (properties === undefined) {
        properties = new _AWTEventProperties.default();
      }

      properties.setPropertyWithPii('Flighting.ClientId', _treatmentService.treatmentService.clientId, _webjsSdk.AWTPiiKind.NotSet);
      properties.setProperty(_ISS.IssPropertyName.Result_FailureType, _ISS.IssResultType.Success);
      var operationName;

      if (state === _webjsSdk.AWTSessionState.Started) {
        operationName = '@app/session/started';
      } else {
        operationName = '@app/session/ended';
      }

      properties.setProperty(_ISS.IssPropertyName.Action_OperationName, operationName);

      this._setEventProperties(properties);

      properties.setProperty(_ISS.IssPropertyName.ExtendedProperties_ExtendedProperties, (0, _stringify.default)({
        isTouch: this.isTouch,
        screenWidth: this.screenWidth,
        screenHeight: this.screenHeight,
        windowWidth: this.windowWidth,
        windowHeight: this.windowHeight
      }));

      if (this._defaultProvider) {
        this._defaultProvider.logSession(state, properties);

        this._sessionId = this._defaultProvider.getSessionId();
      }

      (0, _forEach.default)(_context = this._providers).call(_context, function (provider) {
        if (_this2._defaultProvider !== provider) {
          if (_this2._sessionId) {
            provider.setSessionId(_this2._sessionId);
          }

          provider.logSession(state, properties);
        }
      });
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _context2;

      (0, _forEach.default)(_context2 = this._providers).call(_context2, function (provider) {
        return provider.initialize();
      });

      if (this._initError !== undefined) {
        this.logFailure('TelemetryFailure', this._initError + '');
      }

      this.logSession(_webjsSdk.AWTSessionState.Started);
    }
  }, {
    key: "setUserId",
    value: function setUserId(userId, pii, userIdType) {
      var _context3;

      (0, _forEach.default)(_context3 = this._providers).call(_context3, function (provider) {
        return provider.setUserId(userId, pii, userIdType);
      });
    }
  }, {
    key: "getSessionId",
    value: function getSessionId() {
      return this._defaultProvider && this._defaultProvider.getSessionId();
    }
  }, {
    key: "setSessionId",
    value: function setSessionId(_sessionId) {//
    }
  }, {
    key: "setActorObjectId",
    value: function setActorObjectId(oid) {
      this._userObjectId = oid;
    }
  }, {
    key: "setActorTenantId",
    value: function setActorTenantId(tid) {
      this._userTenantId = tid;
    }
  }, {
    key: "logEvent",
    value: function logEvent(event) {
      var _context4;

      this._setEventProperties(event);

      event.setName('IssBusinessEvent');
      event.setProperty(_ISS.IssPropertyName.Result_FailureType, _ISS.IssResultType.Success);
      (0, _forEach.default)(_context4 = this._providers).call(_context4, function (provider) {
        provider.logEvent(event);
      });
    }
  }, {
    key: "logPageView",
    value: function logPageView(id, pageName, category, uri, _referrerUri, event) {
      var _context5,
          _this3 = this;

      if (event === undefined) {
        event = new _AWTEventProperties.default(id);
      }

      event.setProperty(_ISS.IssPropertyName.ExtendedProperties_ExtendedProperties, (0, _stringify.default)({
        isTouch: this.isTouch,
        screenWidth: this.screenWidth,
        screenHeight: this.screenHeight,
        windowWidth: this.windowWidth,
        windowHeight: this.windowHeight
      }));
      event.setProperty(_ISS.IssPropertyName.Result_ResultType, _ISS.IssResultType.Success);

      this._setEventProperties(event);

      (0, _forEach.default)(_context5 = this._providers).call(_context5, function (provider) {
        provider.logPageView(id, pageName, category, uri, _this3.referrer, event);
      });
    }
  }, {
    key: "logFailure",
    value: function logFailure(signature, detail, category, id, properties) {
      var _context6;

      if (properties === undefined) {
        properties = new _AWTEventProperties.default(id);
      }

      if (properties instanceof _AWTEventProperties.default) {
        this._setEventProperties(properties);

        properties.setProperty(_ISS.IssPropertyName.Result_FailureSignature, signature);
        properties.setProperty(_ISS.IssPropertyName.Result_ResultDescription, detail);
        properties.setProperty(_ISS.IssPropertyName.Result_ResultType, _ISS.IssResultType.Failure);
      }

      (0, _forEach.default)(_context6 = this._providers).call(_context6, function (provider) {
        provider.logFailure(signature, detail, category, id, properties);
      });
    }
  }, {
    key: "flush",
    value: function flush() {
      var _context7;

      (0, _forEach.default)(_context7 = this._providers).call(_context7, function (provider) {
        return provider.flush();
      });
    }
  }, {
    key: "flushAndTeardown",
    value: function flushAndTeardown() {
      var _context8;

      (0, _forEach.default)(_context8 = this._providers).call(_context8, function (provider) {
        return provider.flushAndTeardown();
      });
    }
  }, {
    key: "_setEventProperties",
    value: function _setEventProperties(event) {
      if (this._userObjectId) {
        event.setProperty(_ISS.IssPropertyName.Actor_ObjectId, this._userObjectId);
      }

      if (this._userTenantId) {
        event.setProperty(_ISS.IssPropertyName.Actor_TenantId, this._userTenantId);
      }

      if (this._userAgent !== undefined) {
        event.setProperty(_ISS.IssPropertyName.Caller_ClientUserAgent, this._userAgent);
      }

      if (this._sessionId !== undefined) {
        event.setProperty(_ISS.IssPropertyName.Caller_SessionId, this._sessionId);
      }

      var flights = _treatmentService.treatmentService.getCachedFlightIds();

      event.setProperty('AppInfo.ExperimentIds', flights);

      if (process.env.APP_TELEMETRY_SOURCE_NAMESPACE) {
        event.setProperty(_ISS.IssPropertyName.SourceNamespace, process.env.APP_TELEMETRY_SOURCE_NAMESPACE);
      }

      event.setProperty(_ISS.IssPropertyName.Flighting_FlightName, flights);
    }
  }, {
    key: "providers",
    get: function get() {
      return this._providers;
    }
  }]);
  return Telemetry;
}();

exports.Telemetry = Telemetry;
var telemetry = new Telemetry();
exports.telemetry = telemetry;